// extracted by mini-css-extract-plugin
export var labelWrapper = "_dn-0";